import { generateClient } from "aws-amplify/api";
import { getDemographicVoteDetails } from "@/graphql/queries";
import { use } from "apexcharts";
const client = generateClient();
export const GetDemographicVoteDetails = {
  methods: {
    async GetDemographicVoteDetailsMethod(Obj) {
      try {
        this.loading = true;
        let result = await client.graphql({
          query: getDemographicVoteDetails,
          variables: {
            input: {
              user_id: this.$store.getters.get_current_user_details.user_id,
              pollId: Obj.pollId,
              country: Obj.country,
              state: Obj.state,
              district: Obj.district,
              pincode: Obj.pincode,
              age_group: Obj.age_group,
            },
          },
        });
        var ResultObj = JSON.parse(result.data.getDemographicVoteDetails);
        if (ResultObj.status == 200 || ResultObj.status === "SUCCESS") {
          this.GetDemographicVoteDetailsList = ResultObj.data.items;
          return ResultObj.data.items;
        }
        this.loading = false;
      } catch (error) {
        this.GetDemographicVoteDetailsList = [];
        this.loading = false;
        console.log("Error", error);
      }
    },
  },
};
